import ApiService from "@/services/api.service";
import Vue from "vue";

const state = () => ({
    all: []
})

// actions
const actions = {
    loadAll(context) {
        ApiService.get("/places").then(response => {
            context.commit("SET", response.data);
        });
    },
    add(context, place) {
        return new Promise((resolve, reject) => {
            ApiService.post("/places", place)
                .then(response => {
                    context.commit("ADD", response.data);
                    context.dispatch("loadAll");
                    resolve();
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    update(context, place) {
        return new Promise((resolve, reject) => {
            ApiService.put("/places/" + place.id, place)
                .then(response => {
                    context.commit("UPDATE", response.data);
                    context.dispatch("loadAll");
                    resolve();
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
};

// mutations
const mutations = {
    ADD(state, item) {
        state.all.push(item);
    },
    SET(state, items) {
        state.all = items;
    },
    UPDATE(state, item) {
        const index = state.all[item.id];
        Vue.set(state.all, index, item);
    },
    DEL(state, item) {
        state.all.splice(state.all[item.id], 1);
    }
};

const getters = {
    getAll: (state) => {
        return state.all
    },
    getById: (state) => (id) => {
        return state.all.find(item => item.id === id)
    },
    getByIri: (state) => (iri) => {
        return state.all.find(item => '/places/' + item.id === iri)
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}